import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';
import { CONTACT_INFO } from '@/lib/data';
import { LUXE } from '@/constants/testIds';

export const Footer = () => {
  return (
    <footer className="border-t border-[#C9A24A]/15 bg-[#0B0F1A] pt-20 pb-10">
      <div className="luxe-container grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <span className="flex items-center justify-center w-10 h-10 border border-[#C9A24A]/60 rotate-45">
              <span className="-rotate-45 text-[#C9A24A] font-serif text-lg leading-none">
                L
              </span>
            </span>
            <div className="flex flex-col leading-tight">
              <span className="font-serif text-lg tracking-widest text-white">
                LAVISH LUXE
              </span>
              <span className="text-[10px] uppercase tracking-[0.32em] text-[#C9A24A]">
                Detailing
              </span>
            </div>
          </div>
          <p className="text-white/60 max-w-md leading-relaxed">
            {CONTACT_INFO.tagline}. Premium interior and exterior detailing
            services designed to elevate, protect, and restore your vehicle.
          </p>
          <Link
            to="/booking"
            data-testid={LUXE.footerBookCta}
            className="btn-gold mt-8"
          >
            Book Your Detail
          </Link>
        </div>

        <div>
          <h4 className="luxe-eyebrow mb-6">Navigate</h4>
          <ul className="space-y-3">
            {[
              { to: '/', label: 'Home' },
              { to: '/services', label: 'Services & Pricing' },
              { to: '/gallery', label: 'Gallery' },
              { to: '/about', label: 'About' },
              { to: '/booking', label: 'Booking' },
              { to: '/contact', label: 'Contact' },
            ].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className="text-white/70 hover:text-[#C9A24A] transition-colors text-sm"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="luxe-eyebrow mb-6">Contact</h4>
          <ul className="space-y-4 text-sm">
            <li>
              <a
                href={`tel:${CONTACT_INFO.phoneRaw}`}
                data-testid={LUXE.footerCall}
                className="flex items-start gap-3 text-white/70 hover:text-[#C9A24A] transition-colors"
              >
                <Phone size={16} className="text-[#C9A24A] mt-0.5" />
                {CONTACT_INFO.phone}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${CONTACT_INFO.email}`}
                data-testid="footer-email"
                className="flex items-start gap-3 text-white/70 hover:text-[#C9A24A] transition-colors break-all"
              >
                <Mail size={16} className="text-[#C9A24A] mt-0.5 shrink-0" />
                {CONTACT_INFO.email}
              </a>
            </li>
            <li className="flex items-start gap-3 text-white/70">
              <MapPin size={16} className="text-[#C9A24A] mt-0.5 shrink-0" />
              {CONTACT_INFO.area}
            </li>
          </ul>
          <div className="flex items-center gap-4 mt-6">
            <a
              href={CONTACT_INFO.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              data-testid="footer-instagram"
              className="w-9 h-9 flex items-center justify-center border border-[#C9A24A]/30 text-[#C9A24A] hover:border-[#C9A24A] hover:bg-[#C9A24A]/10 transition-all"
            >
              <Instagram size={16} />
            </a>
            <a
              href="#"
              aria-label="Facebook"
              data-testid="footer-facebook"
              className="w-9 h-9 flex items-center justify-center border border-[#C9A24A]/30 text-[#C9A24A] hover:border-[#C9A24A] hover:bg-[#C9A24A]/10 transition-all"
            >
              <Facebook size={16} />
            </a>
          </div>
        </div>
      </div>

      <div className="luxe-container mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs uppercase tracking-[0.24em] text-white/40">
        <span>© {new Date().getFullYear()} Lavish Luxe Detailing</span>
        <span>Luxury • Precision • Protection</span>
      </div>
    </footer>
  );
};
